import styled, { css } from 'styled-components';

export const StyledSubTitle = styled.div(
  ({ theme, size = 's', textDecoration = 'normal' }) => css`
    display: flex;
    font-size: ${theme.fontSize[size]};
    margin-bottom: ${theme.spacing.s};
    font-style: ${textDecoration};
  `
);
